// XNGAGE CONFIDENTIAL
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createWidgetElement } from "@insite/client-framework/Components/ContentItemStore";
import { FC } from "react";

interface OwnProps {
    title: string;
    orderNumber: string;
    isVmiOrderDetailsPage?: boolean;
    isVmiOrder?: boolean;
    // XNG-Changes
    onClick?: () => void;
}

type Props = OwnProps;

const OrderDetailPageTypeLink: FC<Props> = ({ title, orderNumber, isVmiOrderDetailsPage, isVmiOrder, onClick }) => {
    return createWidgetElement("Basic/PageTypeLink", {
        fields: {
            pageType: isVmiOrderDetailsPage ? "VmiOrderDetailsPage" : "OrderDetailsPage",
            overrideTitle: title,
            queryString: isVmiOrderDetailsPage
                ? `orderNumber=${orderNumber}`
                : isVmiOrder
                ? `orderNumber=${orderNumber}&isVmiOrder=true`
                : `orderNumber=${orderNumber}`,
            // XNG-Changes
            onClick,
        },
    });
};

export default OrderDetailPageTypeLink;

